import { FC, useMemo } from "react";
import { Warning } from "theme/icons";

import { Box } from "@mui/material";
import { styled } from "@mui/system";

import { Typography } from "../../index.tsx";

type PillProps = {
  variant: "success" | "warning" | "error";
};

// @ts-ignore
const StyledWrap = styled(Box)(({ theme, variant }) => {
  return {
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    columnGap: theme.spacing(0.75),
    backgroundColor:
      variant === "warning"
        ? '#F3AF19'
        : variant === "success"
          ? theme.palette.background.active
          : theme.palette.error.main,
    color: theme.palette.primary.main,
    padding: theme.spacing(0.75, 1),
    width: "fit-content",
  };
});

const Pill: FC<PillProps> = ({ variant }) => {
  const text = useMemo(() => {
    switch (variant) {
      case "error":
        return "Скасовано";
      case "success":
        return "Бронювання підтверджене";
      case "warning":
        return "Очікує на оплату";
      default:
        return "";
    }
  }, [variant]);

  return (
    // @ts-ignore
    <StyledWrap variant={variant}>
      <Warning />
      <Typography variant="body2" color="secondary">
        Статус оплати: {text}
      </Typography>
    </StyledWrap>
  );
};

export default Pill;
